import React from 'react';
import PropTypes from 'prop-types';
import { flowRight as compose } from 'lodash';
import { FormattedMessage, injectIntl } from 'react-intl';
import { connect } from 'react-redux';
import Col from 'react-bootstrap/lib/Col';
import cx from 'classnames';
import withStyles from 'isomorphic-style-loader/withStyles';

import Link from '../Link';
import UnreadMessages from './UnreadMessages';
import DashboardSideMenu from './DashboardSideMenu';

import { unreadThreadsQuery } from '../../lib/graphql/message';
import messages from '../../locale/jsonMessages';
import { withQuery } from '../../hoc/withGraphql';

import arrow from '/public/siteImages/rightSideArrow.svg';
import handIcon from '/public/siteImages/dashBoardHandIcon.png';
import allMessages from '/public/siteImages/messages.svg';
import reviews from '/public/siteImages/reviews.svg';
import youCars from '/public/siteImages/yourCars.svg';

import cs from '../../components/commonStyle.css';
import s from './Dashboard.css';

const Dashboard = (props) => {
  const { account, allUnreadThreads: { loading, getUnreadThreads }, intl: { formatMessage } } = props;
  const newMessages = !loading && getUnreadThreads ? getUnreadThreads.length : 0;
  const messageCount = `${formatMessage(messages.messages)} (${newMessages} ${formatMessage(messages.messagesNew)})`;

  let userId = account?.userId, firstName = account?.firstName;

  return (
    <>
      <Col xs={12} sm={12} md={4} lg={4} className={cs.spaceTop6}>
        <DashboardSideMenu isDashboardPage />
      </Col>
      <Col xs={12} sm={12} md={8} lg={8} className={cs.spaceTop6}>
        <div className={cx(cs.commonBorderSection, cs.spaceBottom3, s.bgColor, s.handIconGrid)}>
          <div>
            {firstName && (
              <h3 className={cx(cs.commonTotalText, cs.fontWeightBold, cs.paddingBottom3)}>
                {`${formatMessage(messages.dashBoardHeader1)}, ${firstName}`}
              </h3>
            )}
            <p className={cs.commonMediumText}>
              <FormattedMessage {...messages.dashBoardInfo} />
            </p>
          </div>
          <img src={handIcon} alt="Welcome Hand" />
        </div>

        <div className={cx(s.btnMainGrid, cs.spaceBottom6)}>
          <DashboardLink to="/inbox" icon={allMessages} text={<FormattedMessage {...messages.allMessages} />} />
          <DashboardLink to="/user/reviews/about-you" icon={reviews} text={<FormattedMessage {...messages.reviews} />} customClass={s.reviewMargin} />
          <DashboardLink to="/cars" icon={youCars} text={<FormattedMessage {...messages.yourLists} />} />
        </div>

        <div className={cx(cs.commonBorderSection, 'whiteBgColor')}>
          <h4 className={cx(cs.commonContentText, cs.fontWeightBold)}>{messageCount}</h4>
          <UnreadMessages userId={userId} loading={loading} getUnreadThreads={getUnreadThreads} />
        </div>
      </Col>
    </>
  );
};

const DashboardLink = ({ to, icon, text, customClass }) => (
  <Link to={to} className={cx(cs.commonContentText, cs.fontWeightMedium, cs.siteTextColor, cs.textDecorationNone, s.btnDisplayGrid, customClass, 'whiteBgColor')}>
    <img src={icon} alt="icon" />
    <div className={s.btnDisplayFlex}>
      <h4 className={cx(cs.commonMediumText, cs.fontWeightNormal)}>{text}</h4>
      <img src={arrow} className={cx(cs.blueLeftArrow, 'loginArrowRTL', 'blueLeftArrowRTL')} alt="arrow" />
    </div>
  </Link>
);

Dashboard.propTypes = {
  intl: PropTypes.object.isRequired,
  account: PropTypes.shape({
    userId: PropTypes.string,
    firstName: PropTypes.string
  }).isRequired,
  siteName: PropTypes.string.isRequired,
  allUnreadThreads: PropTypes.shape({
    loading: PropTypes.bool.isRequired,
    getUnreadThreads: PropTypes.array
  }).isRequired
};

const mapState = (state) => ({
  account: state.account.data,
  siteName: state.siteSettings.data.siteName
});

export default compose(
  injectIntl,
  withStyles(cs, s),
  connect(mapState),
  withQuery(unreadThreadsQuery, {
    name: 'allUnreadThreads',
    options: {
      ssr: false,
      fetchPolicy: 'network-only'
    }
  })
)(Dashboard);
